import ajax from '../utils/request'
import utils from '../utils/'
import filters from '../filters'
import config from '../config'
import state from '../store/state'

export default {
  /**
   * 获取服务器时间
   */
  getTime () {
    const time = utils.storage.get('zxcvbnmtime')

    if (time && typeof time === 'number') {
      return Promise.resolve({time: filters.timestamp(time)})
    }

    return ajax({
      type: 'get',
      url: 'public/v1/misc/getTime'
    }).then(res => {
      return {
        time: filters.timestamp(res.time)
      }
    })
  },
  /**
   * 获取全部导航列表
   */
  getNavList () {
    return ajax({
      type: 'get',
      url: 'public/v1/config/getNav'
    })
  },
  /**
   * 初始化广告配置
   * @see https://yapi.geekbang.org/project/119/interface/api/6594
   */
  initAdvertising () {
    return ajax({
      host: config.adHost,
      type: 'get',
      url: 'public/serving/init'
    })
  },
  /**
   * 获取广告数据
   * @see https://yapi.geekbang.org/project/119/interface/api/6420
   * @param {Object} data              接口参数
   * @param {String} data.place_id     广告位 ID
   * @param {Number} data.place_type   广告类型 [1:普通广告,2:feed流广告（有楼层）]
   * @param {Object} data.floor        广告楼层信息
   * @param {Number} data.begin        开始楼层，从 1 开始
   * @param {Number} data.end          结束楼层，-1 表示获取全部楼层的全部广告
   * @param {String} data.page_tag     页面关联标签
   */
  getAdvertising (data) {
    return ajax({
      host: config.adHost,
      url: 'public/serving/v2',
      data
    })
    /**
     * @param {Url}    pc  素材 url, PC 端
     * @param {Url}    mb  素材 url, 移动端
     * @param {Url}    lp  广告主落地页 url
     * @param {Url}    v   广告展示监控 url
     * @param {Url}    c   广告点击监控 url
     * @param {String} d   广告描述
     * @param {Number} mt  素材类型 [1:普通,2:大图文,3:小图文,4:文字]
     */
    .then((res = []) => {
      res = Array.isArray(res) ? res : []

      const list = []

      res.forEach(item => {
        const ideas = []

        item.ms.forEach(idea => {
          ideas.push({
            src: state.isMobile ? idea.mb : idea.pc,
            route: idea.lp,
            visible: idea.v,
            click: idea.c,
            desc: idea.d,
            ideaType: idea.mt
          })
        })

        list.push({
          label: item.d || '',
          ideas: ideas
        })
      })

      return list
    })
    .catch(() => {
      return Promise.resolve([])
    })
  },
  /**
   * 获取首页推荐列表的广告数据
   */
  getHomeRecommondAD () {
    // return ajax({
    //   url: 'public/v1/config/getAdList'
    // })
    return this.getAdvertising({
      place_id: 1,
      place_type: 2,
      floor: {
        begin: 1,
        end: 100
      }
    }).then(res => {
      const list = []

      res.forEach(item => item.ideas.forEach(idea => {
        list.push(idea)
      }))

      return list
    })
  },
  /**
   * 获取首页侧边栏的广告数据
   */
  getHomeSidbarAD () {
    return this.getAdvertising({
      place_id: 3,
      place_type: 1
    }).then(res => {
      if (res[0] && Array.isArray(res[0].ideas)) {
        return res[0].ideas[0]
      }

      return {}
    })
  },
  /**
   * 获取文章详情页的广告数据
   * @param {Number} id    文章 ID
   * @param {Array}  topic 频道文本
   */
  getArticleAD (id, topic) {
    const postData = {
      page_id: id + '',
      place_id: 2,
      place_type: 1,
      page_tag: [].concat(topic)
    }

    return this.getAdvertising(postData).then(res => {
      if (res[0] && Array.isArray(res[0].ideas)) {
        return res[0].ideas[0]
      }

      return {}
    })
  },
  /**
   * 获取文章详情页的 VCRBox 广告数据
   * @param {Number} id    文章 ID
   * @param {Array}  topic 频道文本
   */
  getArticleVcrbox (id, topic) {
    const postData = {
      page_id: id + '',
      place_id: 4,
      place_type: 1,
      page_tag: [].concat(topic)
    }

    return this.getAdvertising(postData)
  },
  /**
   * 获取公众号列表
   */
  getPubList () {
    return ajax({
      type: 'get',
      url: 'public/v1/config/getPub'
    })
  },
  getPhoneList () {
    return ajax({
      host: config.account,
      type: 'get',
      url: 'account/cellphone/list'
    })
  }
}
